module.exports = {"helmetTitle":"Veloe - Editar Contato do Administrador","title":"Contato do administrador","subtitle":"Deixe os contatos da sua empresa atualizados. Assim, podemos ajudar quando for preciso. ;)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","modaTitleError":"Foi Mal!","modaTextError":"Notamos que existe uma inconsistência nos dados de cadastro que você nos passou.  Por Favor, verifique e tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditAdminContact/data.json
// module id = 1757
// module chunks = 0